import { Spacing, Text } from '@vkontakte/vkui';
import image from 'img/crossPromoVkMusicFakedoor/1TbSuccess.png';
import imageDark from 'img/crossPromoVkMusicFakedoor/1TbSuccessDark.png';
import React, { memo, useCallback, useEffect } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { crossPromoVkMusicFakedoor } from 'reactApp/appHelpers/featuresHelpers/features/crossPromoVkMusicFakedoor';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { openSubscriptionsPage } from 'reactApp/utils/openHelpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './CrossPromoVkMusicSeveralSubscriptions.css';

export interface Props {
    onClose: () => void;
}

export const CrossPromoVkMusicSeveralSubscriptions = memo<Props>(({ onClose }) => {
    const sendAnalytics = useCallback((action) => {
        sendPaymentGa({
            action,
            eventCategory: ECategoryGa.modal,
            name: 'upsale_control_subs',
        });
    }, []);

    useEffect(() => {
        sendAnalytics('show');
        emitAnalyticEvent(AnalyticEventNames.CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_SHOW);
    }, []);

    const handleClick = useCallback(() => {
        sendAnalytics('click');
        onClose();

        emitAnalyticEvent(AnalyticEventNames.CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_CLICK);

        openSubscriptionsPage({
            inSameTab: true,
            query: `utm_source=cloud&utm_medium=web_subscriptions&utm_campaign=upsale_control_subs`,
        });
    }, [onClose, sendAnalytics]);
    const handleClose = useCallback(() => {
        sendAnalytics('close');
        onClose();
    }, [onClose, sendAnalytics]);

    if (!crossPromoVkMusicFakedoor) {
        return null;
    }

    const containsDarkTheme = isDarkThemeModeEnabled();

    const content = (
        <>
            <Spacing size={16} />
            <Text className={styles.text} weight="3">
                {'Вы подключили новую подписку — на 1\u00A0ТБ. Если хотите, старые можно отключить вручную в\u00A0личном\u00A0кабинете'}
            </Text>
            <Spacing size={32} />
        </>
    );

    return (
        <WhatsNewDialog
            primaryButtonText="Посмотреть мои подписки"
            title="Теперь у вас несколько подписок"
            imageUrl={containsDarkTheme ? imageDark : image}
            content={content}
            dialogSize="large"
            buttonTheme="vk"
            onClick={handleClick}
            onClose={handleClose}
            closeIconClassName={!containsDarkTheme ? styles.closeIconLight : undefined}
        />
    );
});

CrossPromoVkMusicSeveralSubscriptions.displayName = 'CrossPromoVkMusicSeveralSubscriptions';
